/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

             this.updateAvailability();
       this.updateAddToCartButton();
       this.updateVariantInput();
       this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      // Check if this is a combined listing selection
      const selectedInput = evt.target.closest('input[data-connected-product-url]');
      if (selectedInput && selectedInput.dataset.connectedProductUrl) {
        // For combined listings, load the connected product first
        this.updateUrl(evt);
        return; // Don't update other elements yet - wait for product to load
      }

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
      }

      // Always update variant input, even if variant is null (to clear the form)
      this.updateVariantInput();
      
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      
      // Check if this is a combined listing
      const hasCombinedListingInputs = this.querySelectorAll('input[data-connected-product-url]').length > 0;
      
      let variantAvailable = this.variant && this.variant.available;
      let unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      
             // For combined listings, enable the button if any option is selected
       if (hasCombinedListingInputs) {
         const selectedInput = this.querySelector('input:checked[data-connected-product-url]');
         if (selectedInput) {
           variantAvailable = true;
           unavailableStr = theme.strings.noVariant;
         } else {
           // If no option is selected for combined listings, disable the button
           variantAvailable = false;
           unavailableStr = theme.strings.noVariant;
         }
       }

      if (this.addBtn) {
        this.addBtn.disabled = !variantAvailable;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      
      // Check if this is a combined listing (has inputs with data-connected-product-url)
      const hasCombinedListingInputs = this.querySelectorAll('input[data-connected-product-url]').length > 0;
      
      if (hasCombinedListingInputs) {
        // For combined listings, mark all options as available since they represent different products
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, true, true);
        });
        return;
      }
      
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant && this.data.formatted[this.variant.id]) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        if (priceCurrentEl) {
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        }
        if (priceWasEl) {
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          if (valueEl) {
            valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          }
          if (unitEl) {
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }
        }

        if (unitPriceEl) {
          unitPriceEl.hidden = !this.variant.unit_price_measurement;
        }
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      const priceDefaultEl = this.price.querySelector('.price__default');
      const priceNoVariantEl = this.price.querySelector('.price__no-variant');
      
      if (priceDefaultEl) {
        priceDefaultEl.hidden = !this.variant;
      }
      if (priceNoVariantEl) {
        priceNoVariantEl.hidden = this.variant;
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable && this.data.formatted[this.variant.id] ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

         /**
      * Updates the SKU.
      */
     updateSku() {
       this.sku = this.sku || this.section.querySelector('.product-sku__value');
       if (!this.sku) return;

       const skuAvailable = this.variant && this.variant.sku;
       this.sku.textContent = skuAvailable ? this.variant.sku : '';
       this.sku.parentNode.hidden = !skuAvailable;
     }





    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change') return;
      
      const connectedProductUrl = evt.target.dataset.connectedProductUrl;
      const isQuickAddDrawer = this.closest('quick-add-drawer');
      
      // Check for connected products FIRST (before updateUrl check)
      if (connectedProductUrl) {
        // Update URL only if not in drawer
        if (!isQuickAddDrawer && this.dataset.updateUrl !== 'false') {
          window.history.replaceState({}, '', connectedProductUrl);
        }
        
        // Always load connected product content (even in drawer)
        this.loadConnectedProduct(connectedProductUrl);
        return;
      } else if (this.variant && this.variant.connected_product_url) {
        // Handle combined listing variant from getSelectedVariant
        if (!isQuickAddDrawer && this.dataset.updateUrl !== 'false') {
          window.history.replaceState({}, '', this.variant.connected_product_url);
        }
        this.loadConnectedProduct(this.variant.connected_product_url);
        return;
      }
      
      // For regular variants, respect updateUrl setting
      if (this.dataset.updateUrl === 'false') return;
      
      // Default behavior: update variant parameter
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Loads and replaces connected product content (following quick-add.js pattern)
     * @param {string} productUrl - The URL of the connected product
     */
    async loadConnectedProduct(productUrl) {
      try {
        // Check if we're in a quick-add-drawer context
        const quickAddDrawer = this.closest('quick-add-drawer');
        
        if (quickAddDrawer) {
          // Use the quick-add drawer's native method to handle product loading
          const response = await fetch(productUrl);
          
          if (response.ok) {
            const tmpl = document.createElement('template');
            tmpl.innerHTML = await response.text();
            quickAddDrawer.productEl = tmpl.content.querySelector('.js-product');
            quickAddDrawer.productUrl = productUrl;
            
            // CRITICAL: Replace section IDs to prevent duplicates (same as renderProduct does)
            const sectionId = quickAddDrawer.productEl.dataset.section;
            quickAddDrawer.productEl.innerHTML = quickAddDrawer.productEl.innerHTML.replaceAll(sectionId, 'quickadd');
            
            // Prevent variant picker from updating URL
            const variantPicker = quickAddDrawer.productEl.querySelector('variant-picker');
            if (variantPicker) variantPicker.dataset.updateUrl = 'false';
            
            // Remove size chart modal if it exists
            const sizeChartModal = quickAddDrawer.productEl.querySelector('[data-modal="size-chart"]');
            if (sizeChartModal) sizeChartModal.remove();
            
            // Call updateContent and updateForm to rebuild the drawer
            quickAddDrawer.updateContent();
            quickAddDrawer.updateForm();
            
            // Wait for custom elements to initialize after innerHTML update
            setTimeout(() => {
              // Update media - same logic as renderProduct (lines 226-228 in quick-add.js)
              const activeMedia = quickAddDrawer.productEl.querySelector('.media-viewer__item.is-current-variant');
              if (activeMedia && activeMedia.dataset.mediaId) {
                quickAddDrawer.updateMedia(activeMedia.dataset.mediaId);
              } else {
                // Fallback: use first media item if no variant-specific media
                const firstMedia = quickAddDrawer.productEl.querySelector('.media-viewer__item');
                if (firstMedia && firstMedia.dataset.mediaId) {
                  quickAddDrawer.updateMedia(firstMedia.dataset.mediaId);
                }
              }
              
              // Get the variant picker from the productEl (source of truth)
              const sourceVariantPicker = quickAddDrawer.productEl.querySelector('variant-picker');
              if (sourceVariantPicker) {
                const productData = sourceVariantPicker.getProductData();
                const firstAvailableVariant = productData.product.variants.find(v => v.available) || productData.product.variants[0];
                
                if (firstAvailableVariant) {
                  // Update the form input with correct variant ID
                  const forms = quickAddDrawer.querySelectorAll('.js-product-form-main, .js-instalments-form');
                  forms.forEach(form => {
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput) {
                      variantInput.value = firstAvailableVariant.id;
                      variantInput.disabled = false;
                    }
                  });
                  
                  // Dispatch variant change event
                  quickAddDrawer.dispatchEvent(new CustomEvent('on:variant:change', {
                    bubbles: true,
                    detail: {
                      form: quickAddDrawer.querySelector('.js-product-form-main'),
                      variant: firstAvailableVariant,
                      product: productData.product
                    }
                  }));
                }
              }
              
              // Reinitialize lazy images
              if (window.initLazyImages) window.initLazyImages();
              
              // Dispatch event for other components
              document.dispatchEvent(new CustomEvent('product:loaded', {
                bubbles: true,
                detail: { productEl: quickAddDrawer.productEl, productUrl }
              }));
            }, 0);
          }
          return;
        }
        
        // Regular product page context
        const response = await fetch(productUrl);
        
        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();
          const newProductEl = tmpl.content.querySelector('.js-product');
          const currentProductEl = this.closest('.js-product');
          
          if (newProductEl && currentProductEl) {
            // Same logic as quick-add.js line 203 - prevent section ID conflicts
            const sectionId = newProductEl.dataset.section;
            const currentSectionId = currentProductEl.dataset.section;
            newProductEl.innerHTML = newProductEl.innerHTML.replaceAll(sectionId, currentSectionId);
            
            // Replace the content
            currentProductEl.innerHTML = newProductEl.innerHTML;
            
                         // Get the new variant picker and update the variant
             const newVariantPicker = currentProductEl.querySelector('variant-picker');
             if (newVariantPicker) {
               // Get the first available variant from the loaded product
               const newProductData = newVariantPicker.getProductData();
               const firstAvailableVariant = newProductData.product.variants.find(v => v.available) || newProductData.product.variants[0];
               
               if (firstAvailableVariant) {
                 // Update the variant picker's variant
                 newVariantPicker.variant = firstAvailableVariant;
                 
                                   // Update the form to use the new product's variant
                  const forms = currentProductEl.querySelectorAll('.js-product-form-main, .js-instalments-form');
                  forms.forEach(form => {
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput) {
                      variantInput.value = firstAvailableVariant.id;
                      variantInput.disabled = false;
                      
                    }
                    
                    // Remove any product-id fields that might be added by Shopify
                    const productIdInputs = form.querySelectorAll('input[name="product-id"]');
                    productIdInputs.forEach(input => input.remove());
                    
                    // Also remove any other variant-related fields that might be cached
                    const cachedVariantInputs = form.querySelectorAll('input[name="id"][data-cached]');
                    cachedVariantInputs.forEach(input => input.remove());
                  });
                 
                                  // Update all the UI elements
                  newVariantPicker.updateMedia();
                  newVariantPicker.updateVariantInput();
                  newVariantPicker.updateAddToCartButton();
                  newVariantPicker.updateAvailability();
                  newVariantPicker.updatePrice();
                  newVariantPicker.updateWeight();
                  newVariantPicker.updateBarcode();
                  newVariantPicker.updateBackorderText();
                                                        newVariantPicker.updatePickupAvailability();
                   newVariantPicker.updateSku();
                  
                   // Dispatch variant change event
                 newVariantPicker.dispatchEvent(new CustomEvent('on:variant:change', {
                   bubbles: true,
                   detail: {
                     form: newVariantPicker.productForm,
                     variant: newVariantPicker.variant,
                     product: newVariantPicker.data.product
                   }
                 }));
               }
             }
            
            // Same reinitialization as quick-add.js
            if (window.initLazyImages) window.initLazyImages();
            
            // Dispatch event for other components
            document.dispatchEvent(new CustomEvent('product:loaded', {
              bubbles: true,
              detail: { productEl: currentProductEl, productUrl }
            }));
          }
        }
        
      } catch (error) {
        console.error('Error loading connected product:', error);
        // Fallback to full page redirect
        window.location.href = productUrl;
      }
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (input) {
          // Enable the input if it's disabled
          if (input.disabled) {
            input.disabled = false;
          }
          
          // Check if this is a combined listing
          const hasCombinedListingInputs = this.querySelectorAll('input[data-connected-product-url]').length > 0;
          
          if (this.variant && this.variant.id) {
            input.value = this.variant.id;
          }
          // Add a small delay to ensure the input is properly updated before any form submission
          setTimeout(() => {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }, 0);
        }
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn')?.textContent?.trim();
          selectedOptions.push(selectedText || '');
        } else {
          const checkedInput = selector.querySelector('input:checked');
          selectedOptions.push(checkedInput ? checkedInput.value : '');
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      
      // Check if this is a combined listing (has inputs with data-connected-product-url)
      const hasCombinedListingInputs = this.querySelectorAll('input[data-connected-product-url]').length > 0;
      
      if (hasCombinedListingInputs) {
        // For combined listings, find the selected input with data-connected-product-url
        const selectedInput = this.querySelector('input:checked[data-connected-product-url]');
        if (selectedInput) {
          // For combined listings, we need to load the connected product first
          // Return null initially - the variant will be set after loading the connected product
          return null;
        }
      }
      
      // Regular variant selection
      let selectedVariant = this.data.product.variants.find(
        (v) => selectedOptions.every((val, index) => v.options[index] === val)
      );
      
      // If no variant is found and we have options, try to find the first available variant
      if (!selectedVariant && this.data.product.variants.length > 0) {
        selectedVariant = this.data.product.variants.find(v => v.available) || this.data.product.variants[0];
      }
      
      
      
      return selectedVariant;
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
